import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import Menu from './Menu';



interface MenuTableProps {
  data: Menu[];
  columns: TableColumn<Menu>[];
  customStyles: Record<string, any>;
}

const MenuTable: React.FC<MenuTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<Menu>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default MenuTable;